import { defineMessages } from 'react-intl';

/** The copy of the pitch details panel (design outreach-v2 t2, t3, t4). */
export const detailsMessages = defineMessages({
  crumb: { id: 'app.outreach.details.crumb', defaultMessage: 'Pitch details' },
  crumbPosition: { id: 'app.outreach.details.crumbPosition', defaultMessage: 'Pitch details · {index} of {count}' },
  previous: { id: 'app.outreach.details.previous', defaultMessage: 'Previous person' },
  next: { id: 'app.outreach.details.next', defaultMessage: 'Next person' },

  // the status card
  heroPlanned: { id: 'app.outreach.details.hero.planned', defaultMessage: 'Goes out {when}' },
  heroPlannedNoTime: { id: 'app.outreach.details.hero.plannedNoTime', defaultMessage: 'Planned' },
  heroPlannedSub: {
    id: 'app.outreach.details.hero.plannedSub',
    defaultMessage: 'Plug sends it from your mailbox. Block the person below and the pitch does not go out.',
  },
  heroWriting: { id: 'app.outreach.details.hero.writing', defaultMessage: 'Plug is writing the pitch' },
  heroReview: { id: 'app.outreach.details.hero.review', defaultMessage: 'The pitch waits for you' },
  heroReviewSub: {
    id: 'app.outreach.details.hero.reviewSub',
    defaultMessage: 'Read it, edit it or skip it before it goes out.',
  },
  heroWaiting: { id: 'app.outreach.details.hero.waiting', defaultMessage: 'Waiting for a reply' },
  heroWaitingSub: {
    id: 'app.outreach.details.hero.waitingSub',
    defaultMessage: 'Sent {date}. People often answer in 3 to 5 days.',
  },
  heroOpened: { id: 'app.outreach.details.hero.opened', defaultMessage: 'Opened the song' },
  heroListened: { id: 'app.outreach.details.hero.listened', defaultMessage: 'Listened for {duration}' },
  heroNoReplySub: { id: 'app.outreach.details.hero.noReplySub', defaultMessage: 'No reply yet.' },
  heroReplied: { id: 'app.outreach.details.hero.replied', defaultMessage: '{name} replied' },
  heroAdded: { id: 'app.outreach.details.hero.added', defaultMessage: '{name} added your song' },
  answerInInbox: { id: 'app.outreach.details.answerInInbox', defaultMessage: 'Answer in Inbox' },
  readPitches: { id: 'app.outreach.details.readPitches', defaultMessage: 'Read the pitches' },

  // the timeline
  stepSent: { id: 'app.outreach.details.step.sent', defaultMessage: 'Sent' },
  stepSentFrom: { id: 'app.outreach.details.step.sentFrom', defaultMessage: 'From {email}' },
  stepFollowUpSent: { id: 'app.outreach.details.step.followUpSent', defaultMessage: 'Follow-up sent' },
  stepOpened: { id: 'app.outreach.details.step.opened', defaultMessage: 'Opened the song' },
  stepNotOpened: { id: 'app.outreach.details.step.notOpened', defaultMessage: 'Not opened yet' },
  stepListened: { id: 'app.outreach.details.step.listened', defaultMessage: 'Listened {duration}' },
  stepClicked: { id: 'app.outreach.details.step.clicked', defaultMessage: 'Opened it on {service}' },
  stepReplied: { id: 'app.outreach.details.step.replied', defaultMessage: 'Replied' },
  stepPlaced: { id: 'app.outreach.details.step.placed', defaultMessage: 'Added the song' },
  stepPlacedAt: { id: 'app.outreach.details.step.placedAt', defaultMessage: 'Added the song at position {position}' },
  stepFollowUp: { id: 'app.outreach.details.step.followUp', defaultMessage: 'Follow-up on {date}' },
  stepFollowUpSub: { id: 'app.outreach.details.step.followUpSub', defaultMessage: 'Only if there is no reply.' },

  // the pitch
  pitchTitle: { id: 'app.outreach.details.pitch.title', defaultMessage: 'The pitch' },
  pitchWhatTheyGot: { id: 'app.outreach.details.pitch.whatTheyGot', defaultMessage: 'What they got' },
  pitchWrittenByPlug: { id: 'app.outreach.details.pitch.writtenByPlug', defaultMessage: 'Written by Plug' },
  pitchFrom: { id: 'app.outreach.details.pitch.from', defaultMessage: 'From' },
  pitchTo: { id: 'app.outreach.details.pitch.to', defaultMessage: 'To' },
  pitchNotWritten: {
    id: 'app.outreach.details.pitch.notWritten',
    defaultMessage: 'Plug writes the pitch soon. It shows here when it is ready.',
  },
  showWhole: { id: 'app.outreach.details.pitch.showWhole', defaultMessage: 'Show the whole pitch' },

  // why
  whyTitle: { id: 'app.outreach.details.why.title', defaultMessage: 'Why Plug picked them' },
  fitOf: { id: 'app.outreach.details.why.fit', defaultMessage: 'Fit {score} of 100' },
});
